import { gql } from '@apollo/client';

const zones = gql`
  query Zones($query: String, $limit: Float) {
    buyer {
      getZonesByTextQuery(input: { queryString: $query, limit: $limit }) {
        zones {
          gdsId
          geoData {
            uuid
            name
            county
            stateAbbr
          }
        }
      }
    }
  }
`;

export default zones;
